import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/RootState';
import { PowerBiReportItem } from './PowerBiReportItem';
import styled from 'styled-components/macro';

export const PowerBiReportsList: FC = () => {
    const reports = useSelector((state: RootState) => state.powerBi.reports);
    return (
        <ListContainer>
            <h3>My reports</h3>
            <UL>
                {reports.map((report) => (
                    <PowerBiReportItem report={report} key={report.id} />
                ))}
            </UL>
        </ListContainer>
    );
};
const ListContainer = styled.div`
    width: ${(props) => props.theme.mainMenu.width};
    box-sizing: border-box;
    padding: 0.5em 0 0.5em 1em;
    h3 {
        text-align: center;
        margin: 0 auto 1em;
    }
`;
const UL = styled.ul`
    margin: 0;
    list-style: none;
    padding: 0;
`;
